export default {
  getCookie (cname) {
    var myCookie = null
    if (document.cookie.length > 0) {
      let cstart = document.cookie.indexOf(cname + '=')
      if (cstart !== -1) {
        cstart = cstart + cname.length + 1
        let cend = document.cookie.indexOf(';', cstart)
        if (cend === -1) cend = document.cookie.length
        myCookie = unescape(document.cookie.substring(cstart, cend))
      }
    }
    // if (myCookie === null) {
    //   myCookie = window.localStorage.getItem(cname)
    // }
    return myCookie
  },
  setCookie (cname, value, expiredays) {
    var exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie = cname + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString()) + ';path=/'
    // localStorage.setItem(cname, value)
  }
}



// WEBPACK FOOTER //
// ./src/utils/Cookie.js